import { QueueFunction } from './queue-function'

/**
 * A very simple fifo queue implementation.
 */
export class Queue<T> {
  /**
   * Listeners that subscribed to the queue
   */
  private queue: Array<QueueFunction<T>>

  /**
   * How many active listeners are available
   */
  get length(): number {
    return this.queue.length
  }

  constructor(functions: QueueFunction<T>[] = []) {
    this.queue = functions
  }

  /**
   * Call all subscribed listeners in fifo order.
   *
   * @param value Value that is passed to all listeners.
   */
  call(value: T): void {
    this.queue.forEach(event => event.call(this, value))
  }

  /**
   * Remove all subscribed listeners from the queue.
   */
  clear(): void {
    this.queue = []
  }

  /**
   * Add a listener to the queue.
   */
  push(callback: QueueFunction<T>): void {
    this.queue.push(callback)
  }

  /**
   * Remove a listener from the queue.
   */
  remove(callback: QueueFunction<T>): void {
    this.queue = this.queue.filter(_ => _ !== callback)
  }
}
